<template>
  <v-dialog v-model="show" persistent width="400">
    <v-card>
      <v-toolbar color="primary" dark>{{ titreconfirm }}</v-toolbar>

      <v-card-text class="pa-6">{{ textconfirm }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn   @click.stop="show = false">
          {{ $t('global.cancel') }}
        </v-btn>
        <v-btn color="primary" @click="confirm">
          {{ $t('global.confirm')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Confirm',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false
    },
    titreconfirm: {
      type: String,
      required: true
    },
    textconfirm: {
      type: String,
      required: true
    },
    handleconfirm: {
      type: Function,
      required: true
    }
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    }
  },
  methods: {
    confirm() {
      this.handleconfirm();
      this.$emit('close');
    },
  },
};
</script>
